import { LicenseMonthlySubscriptionTrialSubFormController } from '../controller/LicenseMonthlySubscriptionTrialSubFormController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { LicenseSubFormComponent } from '../../types/LicenseSubFormComponent';
import { CompanyActionContext } from 'apps/webcomponents/src/company/common/types/CompanyActionContext';
import { LicenseMainFormViewData } from '../../licenseMainForm/types/LicenseMainFormViewData';
import { CompanyType } from '../../../company/types/company-type';
import { combineLatest, Observable } from 'rxjs';
import { FormGroupValue } from '../../../ui/gzForm/formGroup/types/form-group-value';
import { CompanyData } from '../../../company/types/company-data';
import { map } from 'rxjs/operators';

export class LicenseMonthlySubscriptionTrialSubFormWebComponent
  extends BaseWebComponentElement
  implements LicenseSubFormComponent
{
  public controller!: LicenseMonthlySubscriptionTrialSubFormController;
  public context: CompanyActionContext;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseMonthlySubscriptionTrialSubFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    return combineLatest([
      this.controller.view.formGroup.valid$,
      this.controller.view.dom.$ownUseProductTypeFormField.valid$,
    ]).pipe(
      map(([formGroupValid, ownUseProductTypeValid]) => {
        return formGroupValid && ownUseProductTypeValid;
      })
    );
  }

  public get value(): FormGroupValue {
    return this.controller.view.getFormValue();
  }

  public setCompanyType(companyType: CompanyType) {
    if (!this.started) {
      return;
    }

    this.controller.setCompanyType(companyType, false);
  }

  public setViewData(viewData: LicenseMainFormViewData) {
    this.controller.setViewData(viewData);
  }

  public setCompanyData(company: CompanyData): void {
    this.controller.setCompanyData(company);
  }
}
